export default "__VITE_ASSET__9a333a00__"